import { useCallback, useReducer } from 'react';
const defaultState = {
    loading: false,
};
export function useAsyncState() {
    const [state, dispatch] = useReducer(reducer, undefined, () => defaultState);
    const pending = useCallback(() => dispatch({ loading: true }), []);
    const resolve = useCallback((data, meta) => dispatch({ data, meta, loading: false }), []);
    const reject = useCallback((error) => dispatch({ error, loading: false }), []);
    return [state, { pending, resolve, reject }];
}
function reducer(_, payload) {
    return payload;
}
//# sourceMappingURL=useAsyncState.js.map